import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { AccountRoleByActorDetails } from '../../Models/Domains/Account/AccountRoleByActorDetails';

declare var IS_RUNNING_IN_APP_POOL;

export class AccountRoleByActorClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(customerId: number): Promise<Array<AccountRoleByActorDetails>, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Account/AccountRoleByActor/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { customerId: customerId }

    return AjaxWrapper.get<Array<AccountRoleByActorDetails>, any>(url, data);
  }
}

